export enum FedopsInteraction {
  ViewStepAtSidebarLayout = 'view-step-at-sidebar-layout',
  LeaveFromProgram = 'leave-from-program',
}
